import { render, staticRenderFns } from "./OrderUpdatePageWrapper.vue?vue&type=template&id=5383747b"
import script from "./OrderUpdatePageWrapper.vue?vue&type=script&lang=js"
export * from "./OrderUpdatePageWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports